export default __webpack_public_path__ + "static/media/claim.472c0ddb.svg";